import { FailedToValidate } from "../failed-to-validate";

export const Incomplete = FailedToValidate;
